/** Connected mailboxes (Connections → Provider accounts) and customer replies on sends. */
export const mailboxEn={
 "conn.mail.title":"Mailboxes",
 "conn.mail.note":"Connect the mailbox you send from. Customers’ replies to MiraOps emails go there, and MiraOps shows who replied on the send. MiraOps reads message headers only, never the text.",
 "conn.mail.connectGmail":"Connect Gmail",
 "conn.mail.connectOutlook":"Connect Outlook",
 "conn.mail.none":"No mailbox connected yet.",
 "conn.mail.disconnect":"Disconnect",
 "conn.mail.checked":"Checked {when}",
 "conn.mail.notChecked":"Not checked yet",
 "conn.mail.owner":"{name}’s mailbox",
 "conn.mail.lastError":"The last check failed ({code}). It tries again in 5 minutes.",
 "conn.mail.status.connected":"Connected",
 "conn.mail.status.sign_in_required":"Sign in again",
 "conn.mail.status.disabled":"Disconnected",
 "conn.mail.back.connected":"Mailbox connected. Replies to your emails will show on each send.",
 "conn.mail.back.cancelled":"Connecting was cancelled. Nothing was saved.",
 "conn.mail.back.failed":"The mailbox couldn’t be connected. Try again.",
 "conn.mail.disconnected":"Mailbox disconnected.",
 "conn.mail.err.mailbox_not_configured":"Mailbox connections aren’t set up yet.",
 "conn.mail.err.rate_limited":"Too many tries. Wait an hour, then try again.",
 "notice.send_replied":"Customer replied",
 "notice.replyDetail":"{from} replied to your email.",
 "notify.ev.send_replied":"Customer replied",
 "notify.evSub.send_replied":"A customer answered an email you sent, in your connected mailbox.",
 "notify.example.send_replied":"buyer@customer.com replied to your email.",
 "history.event.replied":"Customer replied"
};
export type MailboxKey = keyof typeof mailboxEn;
// Russian and Korean: i18n-mailbox-ru.ts / -ko.ts, loaded with their language, so they stay out of the first visit.
